module.exports = __webpack_public_path__ + "media/images/icon__point--text-45bd49405ba5cafb666d124c5ed10449.png";